import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {containerPx} from '@/features/microsite/constants';
import CtaGroup from './CtaGroup';
import FaqAccordion from './FaqAccordion';
import InterestForm from './InterestForm';

MicrositeFaqSection.propTypes = {
  onButtonClick: PropTypes.func,
  itemType: PropTypes.oneOf(['project', 'event']),
  itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  itemName: PropTypes.string
};

export default function MicrositeFaqSection(props) {
  const {onButtonClick, itemType, itemId, itemName} = props;
  const {t} = useTranslation();

  return (
    <section className="bg-cs-yellow-100 py-32">
      <div className={`${containerPx} flex flex-col gap-8`}>
        <div className="flex flex-col gap-9">
          <div className="flex flex-col gap-2.5">
            <p
              className="text-sm font-semibold text-cs-orange-650 leading-normal">{t('microsite.project.faq.eyebrow')}</p>
            <h2
              className="text-3xl font-semibold text-cs-gray-900 leading-tight">{t('microsite.project.faq.heading')}</h2>
            <div className="h-0.5 w-32 bg-cs-orange-650" aria-hidden="true"/>
          </div>
          <FaqAccordion/>
        </div>

        <CtaGroup
          type="primary"
          heading={t('projects.microsite.still_have_questions.heading')}
          body={t('projects.microsite.still_have_questions.body')}
          buttonLabel={t('projects.microsite.still_have_questions.button_label')}
          onButtonClick={onButtonClick}
        />

        <div id="interest-form">
          <InterestForm itemType={itemType} itemId={itemId} itemName={itemName}/>
        </div>
      </div>
    </section>
  );
}
